// extracted by mini-css-extract-plugin
module.exports = {"PlatformCard":"Platforms_PlatformCard__1IBSI","platformTitle":"Platforms_platformTitle__3Xr9S"};